import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';

import YumurtlamaImg from '../../assets/iui.jpeg';
import AsrmEshre from '../../components/asrmEshre';

export function Asilama() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="aşılama" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="aşılama" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="image-wrapper">
            <img src={YumurtlamaImg} alt="Aşılama" />
          </div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <p>
              <TranslateStatic string="asilamaP1" />
            </p>
            <p>
              <TranslateStatic string="asilamaP2" />
            </p>
            <p>
              <TranslateStatic string="asilamaP3" />
            </p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
